import { render } from "./MenuLogin.vue?vue&type=template&id=32cee9b6&scoped=true"
import script from "./MenuLogin.vue?vue&type=script&lang=js"
export * from "./MenuLogin.vue?vue&type=script&lang=js"

import "./MenuLogin.vue?vue&type=style&index=0&id=32cee9b6&scoped=true&lang=css"

import exportComponent from "/home/kitrin/builds/isoevolve/20261004-205117/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32cee9b6"]])

export default __exports__